export default __webpack_public_path__ + "static/media/reminder.ba2bedf9.svg";